<li>
  @if (!isFirst) {
    <hr [class]="hrColorClass" />
  }

  @if (position === 'start') {
    <div class="timeline-start timeline-box">
      <ng-content select="[timeline-content]"></ng-content>
    </div>
  }

  <div class="timeline-middle">
    <ng-content select="[timeline-icon]"></ng-content>
  </div>

  @if (position === 'end') {
    <div class="timeline-end timeline-box">
      <ng-content select="[timeline-content]"></ng-content>
    </div>
  }

  @if (!isLast) {
    <hr [class]="hrColorClass" />
  }
</li>
